import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=3f88a1a2&scoped=true&"
import script from "./EndScreen.vue?vue&type=script&lang=js&"
export * from "./EndScreen.vue?vue&type=script&lang=js&"
import style0 from "./EndScreen.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EndScreen.vue?vue&type=style&index=1&id=3f88a1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88a1a2",
  null
  
)

export default component.exports